angular.module('iqxCore')
.controller('CandidateWelcomeCtrl', function ($scope, $routeParams, $location, $window, LanguageSvc) {
  $scope.navigate=function(n){
    $location.url(n)
  }

  $scope.slides=[]

  //home screen
  $scope.slides.push(
    {
      title:$scope.params.lang.menu.home,
      image:"/assets/welcome-page-images/candidateHomePage.png",
      icon:"fa fa-home",
      iconColor:"#cdcdcd",
      list:[
        {
          title:"Timesheet",
          text:"Gain fast access to your current timesheets"
        },
        {
          title:"Expiring documentation",
          text:"Understand what documents are requiring renewal"
        },
        {
          title:"Missing items",
          text:"Required information will be highlighted here, click on the item to access it"
        }
      ]
    }
  )

  // detials page
  $scope.slides.push(
    {
      title:$scope.params.lang.candidate.details,
      image:"/assets/welcome-page-images/candidateDetailsPage.png",
      icon:"fa fa-pencil",
      iconColor:"#ef9a9a",
      list:[
        {
          title:"Edit",
          text:"Make changes to your information as it changes"
        },
        {
          title:"Auto Update",
          text:"Once saved this information will then be updated for your consultant to view"
        },
        {
          title:"Paperwork",
          text:"Removing the need for unnecessary paper work"
        }
      ]
    }
  )

  // bank details
  if($scope.userHasRight('CANDBANKDETAILSVIEW')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.bankdetails,
        image:"/assets/welcome-page-images/candidateBankDetailsPage.png",
        icon:"fa fa-money",
        iconColor:"#FFCC80",
        list:[
          {
            title:"Docs",
            text:"Access to all documentation and tax information as required"
          },
          {
            title:"Bank info",
            text:"Add and edit your bank details"
          }
        ]
      }
    )
  }

  // documents
  if($scope.userHasRight('DOCCANDDOWNLOAD')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.documents,
        image:"/assets/welcome-page-images/candidateDocumentsPage.png",
        icon:"fa fa-file",
        iconColor:"#81D4FA",
        list:[
          {
            title:"Upload",
            text:"Add documents e.g. CV’s, Headshot, Qualifications etc…"
          },
          {
            title:"Manage",
            text:"All your documents in one place for easy management"
          },
          {
            title:"Access",
            text:"Download and view your documents on the go"
          }
        ]
      }
    )
  }

  // registration
  if($scope.userHasRight('CANDDEPTREG')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.registration,
        image:"/assets/welcome-page-images/candidateRegistrationPage.png",
        icon:"fa fa-briefcase",
        iconColor:"#A5D6A7",
        list:[
          {
            title:"Register",
            text:"Select what sectors are relevant to you whether it be temporary or permanent work"
          },
          {
            title:"Skills",
            text:"Add your current skills/qualifications within the sectors to help consultants match you to the right vacancy"
          },
          {
            title:"Edit",
            text:"Simply remove yourself from a "+LanguageSvc.lang.candidate.department+" if it is no longer relevant for your skills"
          }
        ]
      }
    )
  }

  // jobs
  if($scope.isSwitchedOn('JOBSEARCH')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.jobsearch,
        image:"/assets/welcome-page-images/candidateJobPage.png",
        icon:"fa fa-sticky-note",
        iconColor:"#FFCC80",
        list:[
          {
            title:"Search",
            text:"Access and filter available jobs in an instant"
          },
          {
            title:"Apply",
            text:"Show interest in positions with a single click"
          },
          {
            title:"Applied",
            text:"Understand what jobs you’ve applied for quickly"
          },
          {
            title:"Email",
            text:"Require more information? Use the “Email” button to ask a consultant a question"
          }
        ]
      }
    )
  }

  // diary
  if($scope.userHasRight('DIARY')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.diary,
        image:"/assets/welcome-page-images/candidateDiaryPage.png",
        icon:"fa fa-calendar",
        iconColor:"#FFAB91",
        list:[
          {
            title:"Available",
            text:"Enter when you’re Available, Unavailable and on holiday by selecting the “Enter Availability” button"
          },
          {
            title:"Working",
            text:"View when you’re working and receive directions via google maps"
          },
          {
            title:"View",
            text:"Change view between Day, Week, Month and Year"
          },
          {
            title:"Update",
            text:"By adding your availability a consultant will be able to contact you about relevant vacancies"
          }
        ]
      }
    )
  }

  // timesheets, there is not rights for timesheets
  if(true){
    $scope.slides.push(
      {
        title:"Timesheets",
        image:"/assets/welcome-page-images/candidateTimesheetsPage.png",
        icon:"fa fa-building",
        iconColor:"#CE93D8",
        list:[
          {
            title:"Current",
            text:"View, query and submit current timesheets for approval"
          },
          {
            title:"Expenses",
            text:"Enter expenses where relevant"
          },
          {
            title:"Comment",
            text:"Add comments and Edit where required"
          },
          {
            title:"Complete",
            text:"View completed timesheets and print if required"
          }
        ]
      }
    )
  }

  // reports
  if($scope.userHasRight('MANAGEMENTINFO')){
    $scope.slides.push(
      {
        title:$scope.params.lang.candidate.reports,
        image:false,
        icon:"fa fa-pie-chart",
        iconColor:"grey",
        list:[
          {
            title:false,
            text:"Reports allow you to keep track of what is important to you as a candidate, these are created by your agency"
          }
        ]
      }
    )
  }

})
